import { CreateGMNTask, EditGMNTask } from "@nens/brostar/uploadapi-client";
import { SchemaForFormData } from "@nens/shared-utils";

import { getDocsLinkMarkdown, getTitleAddon } from "@/libs/form-utils";
import { FormType } from "@/types/form-types";

import { pickGmnLibraryFields } from "../../../schema/gmn-schema-library";

const sharedTitle = (type: FormType | undefined) => `GMN-Startregistratie ${getTitleAddon(type)}`;
const sharedDescription = `Dit is het GMN Startregistratie formulier. Selecteer monitoringbuizen om een meetnet aan te maken. ${getDocsLinkMarkdown(
  "GMN"
)}`;

const getGmnStartRegistrationCreateSchema = (
  type: FormType | undefined
): SchemaForFormData<CreateGMNTask> => ({
  type: "object",
  title: sharedTitle(type),
  description: sharedDescription,
  required: ["metadata", "sourcedocumentData"],
  properties: {
    metadata: {
      type: "object",
      required: ["projectNumber", "qualityRegime", "deliveryAccountableParty"],
      properties: pickGmnLibraryFields([
        "projectNumber",
        "qualityRegime",
        "deliveryAccountableParty",
      ]),
    },
    sourcedocumentData: {
      type: "object",
      required: [
        "name",
        "objectIdAccountableParty",
        "deliveryContext",
        "monitoringPurpose",
        "groundwaterAspect",
        "startDateMonitoring",
        "measuringPoints",
      ],
      properties: {
        ...pickGmnLibraryFields([
          "name",
          "objectIdAccountableParty",
          "deliveryContext",
          "monitoringPurpose",
          "groundwaterAspect",
          "startDateMonitoring",
        ]),
        measuringPoints: {
          ...pickGmnLibraryFields(["measuringPoints"]).measuringPoints,
          minItems: 1,
        },
      },
    },
  },
});

const getGmnStartRegistrationEditSchema = (
  type: FormType | undefined
): SchemaForFormData<EditGMNTask> => ({
  type: "object",
  title: sharedTitle(type),
  description: sharedDescription,
  required: ["metadata", "sourcedocumentData"],
  properties: {
    metadata: {
      type: "object",
      required: [
        "projectNumber",
        "broId",
        "qualityRegime",
        "deliveryAccountableParty",
        "correctionReason",
      ],
      properties: {
        ...pickGmnLibraryFields([
          "projectNumber",
          "qualityRegime",
          "deliveryAccountableParty",
          "correctionReason",
        ]),
        broId: { ...pickGmnLibraryFields(["broId"]).broId, readOnly: true },
      },
    },
    sourcedocumentData: {
      type: "object",
      required: [
        "name",
        "objectIdAccountableParty",
        "deliveryContext",
        "monitoringPurpose",
        "groundwaterAspect",
        "startDateMonitoring",
      ],
      properties: {
        ...pickGmnLibraryFields([
          "name",
          "objectIdAccountableParty",
          "deliveryContext",
          "monitoringPurpose",
          "groundwaterAspect",
          "startDateMonitoring",
          "measuringPoints",
        ]),
      },
    },
  },
});

export function getGmnStartRegistrationSchema(args: {
  type: FormType | undefined;
  isEditing: true;
}): SchemaForFormData<EditGMNTask>;
export function getGmnStartRegistrationSchema(args: {
  type: FormType | undefined;
  isEditing: false;
}): SchemaForFormData<CreateGMNTask>;
export function getGmnStartRegistrationSchema(args: {
  type: FormType | undefined;
  isEditing: boolean;
}): SchemaForFormData<EditGMNTask> | SchemaForFormData<CreateGMNTask>;
export function getGmnStartRegistrationSchema({
  type,
  isEditing,
}: {
  type: FormType | undefined;
  isEditing: boolean;
}) {
  return isEditing
    ? getGmnStartRegistrationEditSchema(type)
    : getGmnStartRegistrationCreateSchema(type);
}
